async function req(path: string, init: RequestInit = {}) {
  const r = await fetch(path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init.headers ?? {}) },
    ...init,
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    const err: any = new Error(body.error || r.statusText);
    err.status = r.status; err.body = body;
    throw err;
  }
  if (r.status === 204) return null;
  return r.json();
}

export const api = {
  get: (p: string) => req(p),
  post: (p: string, body?: any) => req(p, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  patch: (p: string, body?: any) => req(p, { method: 'PATCH', body: body ? JSON.stringify(body) : undefined }),
  del: (p: string) => req(p, { method: 'DELETE' }),
};
